import type { LegacyDraftRowsNoticeProps } from "../models/tech-form-validation-ui.models";

export function LegacyDraftRowsNotice({ rows, onRemove }: LegacyDraftRowsNoticeProps) {
  if (rows.length <= 5) return null;
  return (
    <div className="my-3 rounded border border-red-600 p-3" data-tech-form-field="tq3DraftTable" tabIndex={-1}>
      <p>
        This saved form contains extra draft rows. Review them below and remove each extra row from this submission to
        keep five rows.
      </p>
      {rows.slice(5).map((row) => (
        <button key={row.id} type="button" className="mr-3 mt-2 underline" onClick={() => onRemove(row.id)}>
          Remove extra row {row.id} from this submission
        </button>
      ))}
    </div>
  );
}
